import { h, Component, Fragment } from "preact";
import Config from "../../config";
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import {Table, Row, HRow, Cell, HCell, Currency, FilledButton, InputFilter, SelectFilter} from "../../utils/table-utils";
import Session from "../../utils/session";
import AwrabetUserTopUpTable from "../../../awrabet/desktop-components/user/top-up";

const MasterUsersAPI = Config.AccountApiClass;

export default class UserTopUpTable extends AwrabetUserTopUpTable {
    render({iduser, userInfo, currency = null}) {
        const props = this.props;
        return <div class="">
            {!this.state.wallets ? null :
                !this.state.wallets.length ? <Trans>Questo utente non ha wallet</Trans>
                : <Table>
                    <HRow>
                        {props["hide-fido"] == true ? null : <HCell first={true}><Trans>Credit Line</Trans></HCell>}
                        <HCell first={props["hide-fido"] == true}><Trans>Balance</Trans></HCell>
                        {props["hide-fido"] == true ? null : <HCell><Trans>Total Owed</Trans></HCell>}
                        <HCell><Trans>Ricarica Conto</Trans></HCell>
                        <HCell><Trans>Nota</Trans></HCell>
                    </HRow>
                    {this.state.wallets/*.filter(w => w.wallet_type == 'regular' && (!currency || currency == w.currency))*/.map((wallet, i) => <Row>
                        {props["hide-fido"] == true || !this.state.isaffiliate ? null :<Cell class="w-40" first={true}>
                            <Currency currency={wallet.currency} amount={wallet.fido} />
                        </Cell>}
                        <Cell first={props["hide-fido"] == true || !this.state.isaffiliate} class="w-40">
                            <Currency currency={wallet.currency} amount={wallet.balance} />
                        </Cell>
                        {props["hide-fido"] == true || !this.state.isaffiliate ? null :<Cell class="w-40">
                            <Currency currency={wallet.currency} amount={wallet.balance - wallet.fido} />
                        </Cell>}
                        <Cell class="fn-top-up">
                            <div class="flex">
                                <InputFilter class="w-full" placeholder={"0.00 "+wallet.currency+' ('+wallet.wallet_type+')'} />
                            </div>
                            <div class="flex mt-1">
                                <SelectFilter class="mr-1" name="transaction_reason">
                                    <option value="ricarica"><Trans>Ricarica Cash</Trans></option>
                                    <option value="prelievo"><Trans>Prelievo Cash</Trans></option>
                                    {props["hide-fido"] == true|| !this.state.isaffiliate ? null : <option value="ricarica-fido"><Trans>Dai Fido</Trans></option>}
                                    {props["hide-fido"] == true|| !this.state.isaffiliate ? null : <option value="prelievo-fido"><Trans>Togli Fido</Trans></option>}
                                </SelectFilter>
                                <FilledButton
                                    disabled={this.state.loading}
                                    onClick={e => this.operateWallet(
                                        wallet.currency,
                                        e.currentTarget.closest('.fn-top-up').querySelector('input').value,
                                        e.currentTarget.closest('.fn-top-up').querySelector('select').value,
                                        e.currentTarget.closest('.fn-top-up').parentNode.querySelector('textarea').value,
                                        e.currentTarget
                                    )}
                                    class="bg-blue-500 border-blue-500"
                                >
                                    <Trans>Procedi</Trans>
                                </FilledButton>
                            </div>
                        </Cell>
                        <Cell>
                            <textarea name="nota" class="w-full border rounded h-16" style="resize:vertical;"></textarea>
                        </Cell>
                    </Row>)}
                </Table>}
        </div>;
    }
}
